import { flagsFromMe } from '@codex/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { MountedDocPages } from '../../compose/doc-page.js';
import { docBeforeLoad } from '../../compose/open-route.js';

/**
 * `/doc/:id` (1.1 deliverable 23): a document at its own address, guarded as `/` is. Since 1.X
 * stage alpha it renders 1.X's document page with the real editor and 1.G's sync session. Since
 * stage 1a its `beforeLoad` starts `docs.get` beside the session check (`docBeforeLoad`). Since
 * 1.Y stage s2 up to four pages stay mounted across navigation (`MountedDocPages`).
 */
export const Route = createFileRoute('/doc/$id')({
  beforeLoad: ({ params, location, cause }) => docBeforeLoad({ params, location, cause }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: DocRoute,
});

function DocRoute(): React.JSX.Element {
  const { id } = Route.useParams();
  const { me } = Route.useRouteContext();
  // A new id, or a changed `page_split` flag (read with `me` at navigation), is a new page: the
  // session and the editor are keyed together, since a session attaches one editor.
  const pageSplit = flagsFromMe(me).page_split;
  return <MountedDocPages docId={id} me={me} pageSplit={pageSplit} />;
}
